<template>
    <div class="survey-dropdown-group-container">
        <md-field>
            <label v-bind:for="'dropdown_' + field.id">{{field.name? field.name : 'Wybierz'}}</label>
            <md-select v-model="model" name="dropdown"
                       v-bind:id="'dropdown_' + field.id" @md-selected="onModelChange">
                <md-option v-for="(child, index) in field.children"
                           v-bind:key="index"
                           v-bind:value="index">{{child.name}}</md-option>
            </md-select>
        </md-field>
    </div>
</template>

<script>
import store from '../../store';

export default {
  name: 'SurveyDropdownGroup',
  data() {
    return {
      readonlyMode: store.state.visit.readonlyMode,
      model: this.field.value,
    };
  },
  methods: {
    onModelChange() {
      if (this.model === undefined) return;
      this.$emit('modelChange', {
        newVal: this.model,
        oldVal: this.field.value,
        fieldId: this.field.id,
      });
      this.field.value = this.model;
      this.$emit('nodeChange', this.field);
    },
  },
  props: ['field'],
};
</script>

<style src="./SurveyDropdownGroup.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyDropdownGroup/SurveyDropdownGroup.vue